import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { IDueDiligenceUserListModel } from '../../../shared/models/DueDiligenceUserListModel';
import { MultipleEmailIdModel } from '../../../shared/models/MultipleEmailIdModel';
import { IResponseModel } from '../../../shared/models/ResponseModel';
import { LoaderService } from '../../../shared/providers/loader.service';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { IFileUpload } from '../../../shared/models/fileupload';
import { DocAccessListOutputModel } from '../../../shared/models/DocAccessListOutputModel';
import { DashboardTabs } from '../../property-view.component';

interface IUserDDList {
  PropertyId: number;
  LoggedInUserId: number;
  EmailForShare: string[];
  Source: string;
  OMApproval: boolean;
  DDApproval: boolean;
  DocAccessID?: number;
  CAApproval: boolean;
  OMApprovalRejected?: boolean;
  DDApprovalRejected: boolean;
}


@Component({
  selector: 'app-add-confidentiality-Agreement',
  templateUrl: './add-confidentiality-Agreement.component.html',
  styleUrls: ['./add-confidentiality-Agreement.component.css']
})
export class AddConfidentialityAgreementComponent implements OnInit {

  @Input() modalRef: BsModalRef;
  modalRefDelete: BsModalRef;
  @Input() currentDocAccessRequest: DocAccessListOutputModel;
  @Input() propertyGuid: string = '';
  @Input() OMApproval: boolean = false;
  @Input() DDApproval: boolean = false;
  @Input() CAApproval: boolean = false;
  @Input() IsFromDetails: boolean = true;

  user: any;
  loaderService: any;
  response = {} as IResponseModel;
  fileUploadType: string = "single";
  clearFiles: number = 0;
  inputFileUploadForLOI = {} as IFileUpload;
  fileExtensionType: string = "document";
  fileTypes = '.PDF';
  IsConfidentialityAgreementChecked: boolean = false;
  OmApprovalChecked: boolean = false;
  OmApprovalRejected: boolean = false;
  DDApprovalRejected: boolean = false;
  DDApprovalChecked: boolean = false;
  ShowOMRejectButton: boolean = false;
  ShowDDRejectButton: boolean = false;
  DisableOMRejectButton: boolean = true;
  DisableDDRejectButton: boolean = true;
  DisableOMAcceptButton: boolean = false;
  DisableDDAcceptButton: boolean = false;
  showInfoMessage: boolean = false;
  IsShowAgreement: boolean = true
  uploadNewCA: boolean = false;
  selectedFiles: string[] = [];
  email: string = '';
  shareListing = {} as IUserDDList;
  DisplayName: string = '';
  currentOMAction = '';
  currentDDAction = '';
  constructor(private _propertyManagementService: PropertyManagementService, private _fileUploadService: FileUploadService, private loaderServices: LoaderService, private router: Router, public authService: AuthenticationService, private _toastService: ToastService, private modalService: BsModalService, public _validationService: ValidationService) { }

  ngOnInit(): void {
    if (!this.IsFromDetails) {
      this.OMApproval = this.currentDocAccessRequest != null && this.currentDocAccessRequest != undefined ? this.currentDocAccessRequest.OfferMemoReqApproval : false;
      this.DDApproval = this.currentDocAccessRequest != null && this.currentDocAccessRequest != undefined ? this.currentDocAccessRequest.DueDiligenceReqApproval : false;

      if (this.currentDocAccessRequest != null) {
        if (this.currentDocAccessRequest.ConfidentialityAgreement || this.currentDocAccessRequest.DDConfidentialityAgreement) {
          this.CAApproval = true;
        }
      }
    }
    if (this.currentDocAccessRequest != null && this.currentDocAccessRequest != undefined) {
      this.OmApprovalChecked = this.currentDocAccessRequest.RequestForOfferAccess == 'Accepted' ? true : false;
      this.OmApprovalRejected = this.currentDocAccessRequest.RequestForOfferAccess == 'Rejected' ? true : false;
      this.DDApprovalChecked = this.currentDocAccessRequest.RequestForDueDiligenceAccess == 'Accepted' ? true : false;
      this.DDApprovalRejected = this.currentDocAccessRequest.RequestForDueDiligenceAccess == 'Rejected' ? true : false;
      this.IsConfidentialityAgreementChecked = this.currentDocAccessRequest.IsCAAccepted ? true : false;
      this.IsShowAgreement = this.IsConfidentialityAgreementChecked;
      this.DisableDDRejectButton = this.checkRejectCondition(1);
      this.DisableOMRejectButton = this.checkRejectCondition(2);
      this.DisableOMAcceptButton = this.checkAcceptCondition(2);
      this.DisableDDAcceptButton = this.checkAcceptCondition(1);
      this.ShowDDRejectButton = this.currentDocAccessRequest.RequestForDueDiligenceAccess == 'Pending' || this.currentDocAccessRequest.RequestForDueDiligenceAccess == 'Accepted' ? true : false;
      this.DisplayName = this.currentDocAccessRequest?.FileDisplayName != null && this.currentDocAccessRequest?.FileDisplayName != undefined ?
        this.currentDocAccessRequest?.FileDisplayName : 'CA';

      this.DisplayName = this.DisplayName.length > 37 ? this.DisplayName.substring(0, 37) + '...' : this.DisplayName;
      //this.showInfoMessage = this.IsConfidentialityAgreementChecked ? true : false;
      this.bindModel();
    }
    this.user = this.authService.user != null ? this.authService.user : '';
    if (this.currentDocAccessRequest != null && this.currentDocAccessRequest.Email != null) {
      this.email = this.currentDocAccessRequest.Email;
    }
    this.showUpload();
  }

  UploadNewAgreement() {
    this.uploadNewCA = true;
  }

  checkRejectCondition(typeId) {
    if (typeId == 2) {  // OM
      if (this.currentDocAccessRequest.RequestForOfferAccess == 'Accepted' || this.currentDocAccessRequest.RequestForOfferAccess == 'Pending') {
        return false;
      }
      else {
        return true;
      }
    }
    else {  //DD
      if (this.currentDocAccessRequest.RequestForDueDiligenceAccess == 'Accepted' || this.currentDocAccessRequest.RequestForDueDiligenceAccess == 'Pending') {
        return false;
      }
      else {
        return true;
      }
    }
  }
  checkAcceptCondition(typeId) {
    if (typeId == 2) {  // OM
      if (this.currentDocAccessRequest.RequestForOfferAccess == 'Accepted') {
        return true;
      }
      else {
        return false;
      }
    }
    else {  //DD
      if (this.currentDocAccessRequest.RequestForDueDiligenceAccess == 'Accepted') {
        return true;
      }
      else {
        return false;
      }
    }
  }
  AddConfidentialiTyAgreement() {
    let valid = true;
    if (this.IsConfidentialityAgreementChecked && this.uploadNewCA) {
      if (this.selectedFiles == null || this.selectedFiles.length == 0) {
        this._toastService.addToast({ title: 'Error', msg: 'Please Upload the document', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        valid = false;
      }
    }

    if (valid) {
      this.loaderServices.display(true);
      this.shareListing.PropertyId = 0;
      this.shareListing.LoggedInUserId = this.user.Id;
      //this.shareListing.OMApproval = this.OmApprovalChecked;
      //this.shareListing.DDApproval = this.DDApprovalChecked;
      //this.shareListing.OMApprovalRejected = this.OmApprovalRejected;
      //this.shareListing.DDApprovalRejected = this.DDApprovalRejected;
      this.shareListing.CAApproval = this.IsConfidentialityAgreementChecked;
      this.shareListing.DocAccessID = this.currentDocAccessRequest.DARId;
      this._propertyManagementService.EditDocAccessRequest(this.shareListing).subscribe(res => {
        let reult = res;
        if (reult.IsSuccess) {
          if (this.IsConfidentialityAgreementChecked && this.uploadNewCA) {
            let FileName = '';
            if (this.selectedFiles != null) {
              let currentFile = this.selectedFiles[0];
              if (currentFile != null && currentFile != undefined && currentFile['name'] != null && currentFile['name'] != undefined) {
                FileName = currentFile['name'];
                if (FileName.length > 150) {
                  FileName = ''
                }
              }

            }

            if (this.currentDocAccessRequest?.ConfidentialityAgreement && this.currentDocAccessRequest.DDConfidentialityAgreement) {
              this.inputFileUploadForLOI.documentName = FileName == '' ? 'ConfidentialityAgreementT&C.pdf' : FileName;
              this.inputFileUploadForLOI.fileCategoryId = 409;
            }
            else {
              this.inputFileUploadForLOI.documentName =
                FileName == '' ? this.currentDocAccessRequest?.ConfidentialityAgreement ? 'ConfidentialityAgreementT&C.pdf' : 'DueDiligenceT&C.pdf' : FileName;
              this.inputFileUploadForLOI.fileCategoryId = this.currentDocAccessRequest?.ConfidentialityAgreement ? 409 : 410;
            }
            this.inputFileUploadForLOI.objectId = this.currentDocAccessRequest?.DARId;
            this.inputFileUploadForLOI.objectTypeId = 304;
            this.inputFileUploadForLOI.type = "Documents";
            this.inputFileUploadForLOI.IsConfidentialityAgreementDoc = true;
            this.inputFileUploadForLOI.id = this.currentDocAccessRequest?.DARId;
            this._fileUploadService.uploadFiles(this.inputFileUploadForLOI, this.selectedFiles).subscribe(response => {
              this._toastService.addToast({
                title: 'Success',
                msg: 'User details Updated Successfully',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'success'
              });
              this.modalRef.hide();
              this.loaderServices.display(false);
              window.scrollTo(0, 0);
              this.setLink();
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                this.router.navigateByUrl(this.currentRedirectUrl1));
            });
          }
          else {
            this._toastService.addToast({
              title: 'Success',
              msg: 'User details Updated Successfully',
              timeout: 5000,
              theme: 'bootstrap',
              position: 'bottom-right',
              type: 'success'
            });
            this.modalRef.hide();
            this.loaderServices.display(false);
            window.scrollTo(0, 0);
            this.setLink();
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
              this.router.navigateByUrl(this.currentRedirectUrl1));
          }
        }
        else {
          this._toastService.addToast({ title: 'Error Occured ', msg: this.response.ErrorMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      });
    }
  }


  public currentRedirectUrl1: string = '';
  dashboardTabs = DashboardTabs;
  setLink() {
    if (this.router.url.indexOf('docaccesslist') > -1) {
      this.currentRedirectUrl1 = 'docaccesslist?fromMenu=Opportunity';

    }
    else {
      localStorage.setItem('property-dashboard-Tab', this.dashboardTabs.DocAccess.toString());
      this.currentRedirectUrl1 = "/viewproperty/" + this.propertyGuid

    }
  }

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.selectedFiles = selectedFilesListEmitter;

  }

  showUpload() {
    if (this.currentDocAccessRequest != null) {
      if (this.currentDocAccessRequest.CADocumentPath != null && this.currentDocAccessRequest.CADocumentPath != '') {
        this.uploadNewCA = false;
      }
      else {
        this.uploadNewCA = true;
      }
    }
    else {
      this.uploadNewCA = true;
    }
  }

  changeOMAccess(typeId: number, value: boolean) {
    if (typeId == 1) {
      if (value) {
        if (!this.DisableOMRejectButton) {
          this.OmApprovalRejected = false;
        }
        this.shareListing.OMApproval = true;
        this.shareListing.OMApprovalRejected = false;
      }
      else {
        this.shareListing.OMApproval = false;
      }
    }
    if (typeId == 2) {
      if (value) {
        if (!this.DisableOMAcceptButton) {
          this.OmApprovalChecked = false;
        }
        this.shareListing.OMApproval = false;
        this.shareListing.OMApprovalRejected = true;;
      }
      else {
        this.shareListing.OMApprovalRejected = false;;
      }

    }

  }
  changeDDAccess(typeId: number, value: boolean) {
    if (typeId == 1) {
      if (value) {
        if (!this.DisableDDRejectButton) {
          this.DDApprovalRejected = false;
        }
        this.shareListing.DDApproval = true;
        this.shareListing.DDApprovalRejected = false;
      }
      else {
        this.shareListing.DDApproval = false;
      }
    }
    if (typeId == 2) {
      if (value) {
        if (!this.DisableDDAcceptButton) {
          this.DDApprovalChecked = false;
        }
        this.shareListing.DDApproval = false;
        this.shareListing.DDApprovalRejected = true;;
      }
      else {
        this.shareListing.DDApprovalRejected = false;;
      }

    }

  }
  //changeDDAccess(typeId: number, value: boolean) {
  //  if (typeId == 1 && value) {
  //    this.DDApprovalRejected = false;

  //  }
  //  if (typeId == 2 && value) {
  //    this.DDApprovalChecked = false;
  //  }

  //}

  bindModel() {
    this.shareListing.OMApproval = this.OmApprovalChecked;
    this.shareListing.DDApproval = this.DDApprovalChecked;
    this.shareListing.OMApprovalRejected = this.OmApprovalRejected;
    this.shareListing.DDApprovalRejected = this.DDApprovalRejected;
  }
}
